import React, { useCallback } from "react";
import { Column, Row } from "../../../components/layout/flex-layout";
import { Typography } from "../../../components/typography/typography";
import { Checkbox } from "@pacificoseguros/pixie/react/checkbox";
import { useQuotationPopupFormContext } from "../hooks/use-quotation-popup-form";
import { quotationPopupFormDefinition } from "../constants/form-fields-definition";
import { SpacingBox } from "../../../components/layout/spacing-box";

export const QuotationPopupYesNoRadioField: React.FC = () => {
    const rhForm = useQuotationPopupFormContext();
    const { yesNo } = rhForm.watch([quotationPopupFormDefinition.yesNo.key]);
    const handleChange = useCallback((value) => {
        rhForm.setValue("yesNo", value, { shouldValidate: true });
    }, []);
    return (
        <Column data-testid="QuotationPopupYesNoRadioField">
            <SpacingBox mb={8}>
                <Typography variant="secondary">
                    <b>¿Algun trabajador gana más de S/30 000 mensuales?</b>
                </Typography>
            </SpacingBox>
            <Row>
                <Checkbox
                    checked={!yesNo}
                    handleChange={() => handleChange(false)}
                >
                    <Typography fontSize={16}>No</Typography>
                </Checkbox>
                <SpacingBox mr={27} />
                <Checkbox
                    checked={yesNo}
                    handleChange={() => handleChange(true)}
                >
                    <Typography fontSize={16}>Sí</Typography>
                </Checkbox>
            </Row>
        </Column>
    );
};
